<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Services" />
            <ServicesComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ServicesComp from '../Services/ServicesComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ServicesPage',
    components: {
        NavBar,
        PageTitle,
        ServicesComp,
        FooterComp,
    }
}
</script>